import { AppState } from "./model";
import { textSnippetSelector } from "./selectors";
import { detailRoutes } from "./detailRoutes";

const detailRoute = () => ({
    "/:textSnippetId": {
        title: (state: AppState) => textSnippetSelector(state).name || "Text Snippets",
        "/edit": {
            title: "Edit",
        },
        ...detailRoutes
    }
});

export const routes = {
    "/textSnippets": {
        title: "Text Snippets",
        ...detailRoute(),
        authorize: true,
        "/create": {
            title: "Create Text Snippet"
        }
    }
};
